module.exports = __webpack_public_path__ + "media/images/favicons/ms-icon-150x150-716e626b71c6efab2449dab051d53890.png";